import React, { useMemo, useCallback, useState, useEffect } from "react";
import { DataTable } from "@/components";
import ColumnHelper from "@/utils/ColumnHelper";
import { useApi } from "@/";
import { RightWrapper } from "../../../components";

const Contacts = () => {
  const { callApi, error, loading } = useApi();
  const [careers, setCareers] = useState([]);

  useEffect(() => {
    let isMounted = true;

    const fetchData = async () => {
      try {
        const response = await callApi("/admin/getContactUs", "GET", null);
        if (isMounted) {
          if (response.success && response.data) {
            // console.log("Response", response.data);
            setCareers(response.data);
          } else if (response.error) {
            console.log("Error", response.error?.message || "Unknown error");
          }
        }
      } catch (error) {
        if (isMounted) {
          console.log("Error", error);
        }
      }
    };

    fetchData();

    return () => {
      isMounted = false;
    };
  }, []); // Remove callApi from dependencies since it's stable

  // Format date values
  const formatDate = useCallback((dateString) => {
    return new Date(dateString).toLocaleDateString("en-IN", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  }, []);
  // Memoize filtered data to prevent unnecessary re-renders

  // Memoized table columns
  const columns = useMemo(
    () => [
      ColumnHelper({
        header: "Company Name",
        accessorKey: "companyName",
        meta: {
          tooltip: (row) => row.companyName || "N/A",
        },
      }),
      ColumnHelper({
        header: "Email",
        accessorKey: "email",
        meta: {
          tooltip: (row) => row.email || "N/A",
        },
      }),
      ColumnHelper({
        header: "Phone",
        accessorKey: "phone",
        meta: {
          tooltip: (row) => row?.phone|| "N/A",
        },
      }),
      ColumnHelper({
        header: "Message",
        accessorKey: "message",
        meta: {
          tooltip: (row) => row.message || "N/A",
        },
      }),
      ColumnHelper({
        header: "Created Date",
        accessorKey: "createdAt",
        cell: (info) => formatDate(info.row.original.createdAt),
        meta: {
          tooltip: (row) => formatDate(row.createdAt),
        },
      }),
      ColumnHelper({
        header: "Role",
        accessorKey: "role",
        meta: {
          tooltip: (row) => row.role || "N/A",
        },
      }),
    ],
    []
  );
  return (
    <RightWrapper>
      <div className="flex flex-col gap-4 mt-2 px-2 relative pb-20 md:pb-4">
        <DataTable
          columns={columns}
          tittle="Contacts"
          data={careers}
          isLoading={loading}
          showCheckbox={false}
        />
      </div>
    </RightWrapper>
  );
};

export default Contacts;
